// Unified, hand-crafted celestial icon set — used across the site & premium app
// instead of generic/stock iconography. All use currentColor so the parent text
// colour drives them. Rounded, slightly organic strokes for a warmer, human feel.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export function SunIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <circle cx="12" cy="12" r="3.6" fill="currentColor" stroke="none" />
      <g>
        {Array.from({ length: 7 }).map((_, i) => {
          const a = (i / 7) * Math.PI * 2 - Math.PI / 2;
          const r1 = 6.2, r2 = 9;
          return <path key={i} d={`M${(12 + Math.cos(a) * r1).toFixed(2)} ${(12 + Math.sin(a) * r1).toFixed(2)}L${(12 + Math.cos(a) * r2).toFixed(2)} ${(12 + Math.sin(a) * r2).toFixed(2)}`} />;
        })}
      </g>
    </svg>
  );
}

export function MoonIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <path d="M20.5 14.3A7.4 7.4 0 1 1 10.2 3.9a5.9 5.9 0 0 0 10.3 10.4Z" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function SunriseIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <path d="M3 18h18" />
      <path d="M7.5 18a4.5 4.5 0 0 1 9 0" fill="currentColor" fillOpacity="0.9" stroke="currentColor" />
      <path d="M12 3.2v3" /><path d="M5.4 7.6l1.5 1.5" /><path d="M18.6 7.6l-1.5 1.5" />
      <path d="M9.7 5.3L12 3l2.3 2.3" />
    </svg>
  );
}

export function SunsetIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <path d="M3 18h18" />
      <path d="M7.5 18a4.5 4.5 0 0 1 9 0" fill="currentColor" fillOpacity="0.9" stroke="currentColor" />
      <path d="M12 6.2v-3" /><path d="M5.4 7.6l1.5 1.5" /><path d="M18.6 7.6l-1.5 1.5" />
      <path d="M9.7 4L12 6.3 14.3 4" />
    </svg>
  );
}

export function MoonriseIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <path d="M3 19h18" />
      <path d="M15.6 11.2A4.6 4.6 0 1 1 9.3 5a3.7 3.7 0 0 0 6.3 6.2Z" fill="currentColor" stroke="none" />
      <path d="M8 19l2-2 2 2" opacity="0.85" />
    </svg>
  );
}

export function MoonsetIcon({ className = "h-5 w-5" }) {
  return (
    <svg {...base} className={className} aria-hidden="true">
      <path d="M3 19h18" />
      <path d="M15.6 9.2A4.6 4.6 0 1 1 9.3 3a3.7 3.7 0 0 0 6.3 6.2Z" fill="currentColor" stroke="none" />
      <path d="M8 15l2 2 2-2" opacity="0.85" />
    </svg>
  );
}
